var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarNoticeboardBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 1.625C17.1875 1.2106 17.3521 0.813171 17.6451 0.520146C17.9382 0.22712 18.3356 0.0625 18.75 0.0625H21.875C22.2894 0.0625 22.6868 0.22712 22.9799 0.520146C23.2729 0.813171 23.4375 1.2106 23.4375 1.625V20.375H24.2188C24.426 20.375 24.6247 20.4573 24.7712 20.6038C24.9177 20.7503 25 20.949 25 21.1562C25 21.3635 24.9177 21.5622 24.7712 21.7087C24.6247 21.8552 24.426 21.9375 24.2188 21.9375H0.78125C0.57405 21.9375 0.375336 21.8552 0.228823 21.7087C0.08231 21.5622 0 21.3635 0 21.1562C0 20.949 0.08231 20.7503 0.228823 20.6038C0.375336 20.4573 0.57405 20.375 0.78125 20.375H1.5625V15.6875C1.5625 15.2731 1.72712 14.8757 2.02015 14.5826C2.31317 14.2896 2.7106 14.125 3.125 14.125H6.25C6.6644 14.125 7.06183 14.2896 7.35485 14.5826C7.64788 14.8757 7.8125 15.2731 7.8125 15.6875V20.375H9.375V9.4375C9.375 9.0231 9.53962 8.62567 9.83265 8.33265C10.1257 8.03962 10.5231 7.875 10.9375 7.875H14.0625C14.4769 7.875 14.8743 8.03962 15.1674 8.33265C15.4604 8.62567 15.625 9.0231 15.625 9.4375V20.375H17.1875V1.625ZM18.75 20.375H21.875V1.625H18.75V20.375ZM14.0625 20.375V9.4375H10.9375V20.375H14.0625ZM6.25 20.375V15.6875H3.125V20.375H6.25Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarNoticeboardBlue);
export default __webpack_public_path__ + "static/media/sidebar-noticeboard-blue.c863483d2344dbfe1f810d8294c61ceb.svg";
export { ForwardRef as ReactComponent };